<div @animateIn @animateOut class="tw-flex tw-justify-center tw-items-center tw-h-screen tw-w-screen">
  <div class="tw-max-w-sm tw-w-full tw-mx-4">
    <div class="tw-mx-auto tw-w-2/3">
      <img class="tw-mb-6" src="assets/images/2017-logo.svg" />
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
</div>
